<template>
  <div v-if="this.selectedProduct">
    <product-form
      :product="this.selectedProduct" 
      action="put"
      @update-price="(value) => { selectedProduct.price = value}" 
    />
  </div>
</template>

<script>
import ProductForm from "@/components/Products/ProductForm";
import { mapActions, mapState } from "vuex";
import axios from "axios";

export default {
  components: {
    ProductForm
  },
  data() {
    return {
      product: null
    }
  },
  computed: {
    ...mapState("products", ["selectedProduct"])
  },
  methods: {
    ...mapActions("products", ["fetchProduct"]),
  },
  mounted () {
    let params = this.$route.params;
    this.fetchProduct({id: params.id, myProduct: "true"});
  }
};
</script>


    